export default __webpack_public_path__ + "static/media/register-img.6d5588a5.svg";